<template>
  <section class="dd-effects__mode dd-wall-card">
    <header class="dd-effects__mode-header dd-wall-card-header">
      <h2 class="dd-effects__section-title">
        <slot name="title">{{ $t('wall.effects.mode.title') }}</slot>
      </h2>
      <p v-if="$slots.subtitle" class="dd-effects__mode-subtitle">
        <slot name="subtitle"></slot>
      </p>
    </header>
    <div class="dd-effects__mode-body">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'EffectModeSelector',
};
</script>
